<template>
  <div class="side-wrapper">
    <div class="nav-wrapper" v-for="(item, index) in navList" :key="index">
      <div class="title">{{ item.title }}</div>
      <div class="col-list">
        <div
          :class="{ 'col-item': true, active: v.link == $route.path }"
          @click="routeTo(v.link)"
          v-for="(v, index) in item.colList"
          :key="index"
        >
          {{ v.text }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navList: [
        {
          title: this.$t("Side.ManagementCenter"),
          colList: [
            {
              text: "集運首頁",
              title: "Side.ManagementHomepage",
              link: "/manageHome",
            },
            {
              text: "預報單號",
              title: "Side.Forecastpackage",
              link: "/newBag",
            },
            { text: "我的包裹", title: "Side.Mypackage", link: "/myBag" },
            { text: "我的訂單", title: "Side.Myorder", link: "/myOrder" },
            { text: "訂單追蹤", title: "Side.ddgz", link: "/ordertracking" },
            { text: "自提點查詢", title: "Side.ddgz", link: "/pick" },
            {
              text: "國内快遞追蹤",
              title: "Side.Domesticordertracking",
              link: "/domesticexpresstracking",
            },

            // { text: "同行订单导入", link: "/orderimport" },
            // { text: "单个订单详细", link: "/detailedorder" },
          ],
        },
        {
          title: "用戶中心",
          colList: [
            {
              text: "個人信息",
              title: "Side.Personal",
              link: "/personalCenter",
            },
            { text: "優惠券", title: "Side.coupon", link: "/volume" },
            {
              text: "消費記錄",
              title: "Side.Consumptionflow",
              link: "/consumptionflow",
            },
            {
              text: "銀行轉賬",
              title: "Side.banktransfer",
              link: "/banktransfer",
            },
            {
              text: "我的積分",
              title: "Side.Recommended",
              link: "/integralcenter",
            },
            {
              text: "收貨地址",
              title: "Side.Receiving",
              link: "/shippindaddress",
            },
          ],
        },
        {
          title: "推廣中心",
          colList: [
            {
              text: "推廣鏈接",
              title: "Side.Promotionlink",
              link: "/promotionlink",
            },
            {
              text: "我的推薦",
              title: "Side.Myrecommendation",
              link: "/myrecommendation",
            },
            { text: "我的收益", title: "Side.Myearnings", link: "/myearnings" },
          ],
        },
        {
          title: "會員服務",
          colList: [
            // { text: "联系方式", link: "/contact" },
            { text: "系统公告", title: "Side.answer", link: "/answer" },
            { text: "新手教學", title:"Side.Noviceguidance",link: "/noviceguidance" },
          ],
        },
      ],
    };
  },
  methods: {
    routeTo(link) {
      console.log(link);
      this.$router.push(link);
    },
  },
};
</script>
<style lang="scss" scoped>
.side-wrapper {
  width: 116px;
  height: 750px;
  background: #fff;
  border-radius: 5px;
  // padding: 0px 20px 8px 22px;
  box-sizing: border-box;
  margin-right: 14px;
  text-align: center;
  .nav-wrapper {
    margin-bottom: 28px;
    .title {
      font-size: 16px;
      color: #fbf0f0;
      font-weight: 500;
      line-height: 1;
      background: #7966fe;
      line-height: 30px;
    }
    .col-list {
      .col-item {
        font-weight: 400;
        font-size: 12px;
        color: #666;
        margin-top: 16px;
        line-height: 1;
        cursor: pointer;
        &.active {
          @include color($_color);
        }
        &:hover {
          @include color($_color);
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/layout/side/index.vue